module.exports = __webpack_public_path__ + "img/Marriott-Hotel-Courtyard.871355c8.jpg";